import configureStore from "redux/configureStore";
let store = null;

export function createStore(history) {
  store = configureStore(history);
  return store;
}

export function getState() {
  return store.getState();
}

export function getDispatch() {
  return store.dispatch;
}

// for store testing
export function setStore(_store) {
  store = _store;
}
